import { createContext, Dispatch, useReducer, useRef } from "react";
import { ViewerActions } from "./Actions";
import viewerReducer from "./Reducer";
import { initialViewerState, ViewerState } from "./ViewerState";

export interface PendingSectionCreate {
    resolve: (id: string) => void;
    reject: (reason?: string) => void;
}

const ViewerContext = createContext<{
    state: ViewerState;
    dispatch: Dispatch<ViewerActions>;
    pendingSectionCreate: React.MutableRefObject<PendingSectionCreate | null>;
}>({
    state: initialViewerState,
    dispatch: () => undefined,
    pendingSectionCreate: { current: null },
});

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const ViewerContextProvider = ({ children }: any) => {
    const [state, dispatch] = useReducer(viewerReducer, initialViewerState);
    const pendingSectionCreate = useRef<PendingSectionCreate | null>(null);

    return (
        <ViewerContext.Provider value={{ state, dispatch, pendingSectionCreate }}>{children}</ViewerContext.Provider>
    );
};

export { ViewerContext, ViewerContextProvider };
